import { ShipmentLastStatusMessageUpdateResponse } from '@typings/shipment';
import { Listener } from '../types';

const listeners = new Set<Listener>();

export const removeShipmentUpdateListener = (listener: Listener) => {
  listeners.delete(listener);
};

export const addShipmentUpdateListener = (listener: Listener) => {
  listeners.delete(listener);
  listeners.add(listener);
  return () => removeShipmentUpdateListener(listener);
};

export const notifyShipmentUpdateListeners = (
  shipment: ShipmentLastStatusMessageUpdateResponse['shipment']
) => {
  listeners.forEach((listener) => listener(shipment));
};
